import React from 'react';
import Grid from "@material-ui/core/Grid";
import Typography from "@material-ui/core/Typography";
import ListItem from "@material-ui/core/ListItem";

const AddrForm = (props) => {
    const { roadAddr, roadAddrDetail, jibun, zpcd, admCd, onItemClick } = props;
// admCd 법정동 코드
    return (
        <>
            <ListItem button onClick={() => onItemClick(
                roadAddr,
                roadAddrDetail,
                jibun,
                zpcd,
                admCd ? admCd : "")}>
                <Grid
                    container
                    justifyContent='center'
                    alignItems='center'
                >
                    <Grid item sm={12}>
                        <Typography variant="body1" fontWeight='Medium'>
                            {roadAddr}
                        </Typography>
                    </Grid>
                    <Grid item sm={2}>
                        <Typography variant="body2" style={{color: '#3399ff'}}>
                            우편번호
                        </Typography>
                    </Grid>
                    <Grid item sm={10}>
                        <Typography variant="body2">
                            {zpcd}
                        </Typography>
                    </Grid>
                </Grid>
            </ListItem>
        </>
    )
};

export default AddrForm;
